'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _reactCopyToClipboard = require('react-copy-to-clipboard');

var _countryData = require('country-data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderCountryName = function renderCountryName(code) {
  var country = _lodash2.default.find(_countryData.countries.all, ['alpha2', _lodash2.default.toUpper(code)]);
  return _lodash2.default.get(country, 'name', '-');
};

var countryCellStyle = { maxWidth: 50 };

var SHAREABLE_LINK = window.location.href;

var ReportHeader = function (_React$Component) {
  (0, _inherits3.default)(ReportHeader, _React$Component);

  function ReportHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ReportHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReportHeader.__proto__ || (0, _getPrototypeOf2.default)(ReportHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      copied: false
    }, _this.render = function () {
      var info = _this.props.info;
      var copied = _this.state.copied;

      var generatedTime = (0, _moment2.default)().format('MMMM Do YYYY, h:mm a');
      var hashtagsArray = _lodash2.default.split(info.hashtags, ',');

      var hasCountry = _lodash2.default.has(info, 'reportCountry') && !_lodash2.default.isNil(info.reportCountry);

      return _react2.default.createElement(
        'div',
        null,
        info.hasLogo && _react2.default.createElement(_semanticUiReact.Image, { src: '/images/afterparty.png', alt: 'Afterparty Studios', height: '60' }),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { fluid: true, celled: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { width: 3 },
                'CAMPAIGN'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0, width: 13 },
                _react2.default.createElement(
                  'h3',
                  null,
                  info.campaignName
                )
              )
            ),
            info.influencerName && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'INFLUENCER'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                _react2.default.createElement(
                  'h3',
                  null,
                  info.influencerName
                )
              )
            ),
            info.reportDate && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'REPORT UPDATED'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                _react2.default.createElement(
                  'h3',
                  null,
                  (0, _moment2.default)().format('MMMM Do YYYY')
                )
              )
            ),
            info.reportType && !info.reportCountry && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'REPORT TYPE'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  info.reportType
                )
              )
            ),
            info.reportType && info.reportCountry && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'REPORT TYPE'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(
                  'h3',
                  null,
                  info.reportType
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { style: countryCellStyle },
                'COUNTRY'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _react2.default.createElement(_semanticUiReact.Flag, { name: _lodash2.default.toLower(info.reportCountry) }),
                ' ',
                renderCountryName(info.reportCountry)
              )
            ),
            info.liveDate && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'Start Date'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                (0, _moment2.default)(info.liveDate).format('MMMM Do YYYY')
              )
            ),
            info.endDate && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'End Date'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                (0, _moment2.default)(info.endDate).format('MMMM Do YYYY')
              )
            ),
            info.hashtags && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'HASHTAGS'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                _lodash2.default.map(hashtagsArray, function (ht) {
                  return _react2.default.createElement(_semanticUiReact.Label, { basic: true, color: 'pink', content: _lodash2.default.toLower(ht) });
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'SHAREABLE LINK'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                _react2.default.createElement(
                  'a',
                  null,
                  SHAREABLE_LINK
                ),
                _react2.default.createElement(
                  _reactCopyToClipboard.CopyToClipboard,
                  {
                    text: SHAREABLE_LINK,
                    onCopy: function onCopy() {
                      return _this.setState({ copied: true });
                    }
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\xA0\xA0',
                    _react2.default.createElement(_semanticUiReact.Button, { size: 'mini', color: 'green', basic: true, icon: 'copy', content: 'copy link' })
                  )
                ),
                copied ? _react2.default.createElement(
                  _semanticUiReact.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'thumbs outline up' }),
                  'Copied...'
                ) : null
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'DATA ',
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', color: 'orange' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: hasCountry ? 4 : 0 },
                _react2.default.createElement(
                  'span',
                  null,
                  'Report generated at ',
                  _react2.default.createElement(
                    'strong',
                    null,
                    generatedTime
                  ),
                  '.'
                )
              )
            )
          )
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return ReportHeader;
}(_react2.default.Component);

ReportHeader.propTypes = {
  info: _propTypes2.default.object.isRequired
};

ReportHeader.defaultProps = {
  info: {
    hasLogo: true
  }
};

exports.default = ReportHeader;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/report-header/index.js
 ** module id = 970
 ** module chunks = 0
 **/